<mat-tab-group #tabGroup fxFill mat-stretch-tabs>
  <mat-tab>
    <ng-template matTabLabel>{{ 'cdr.phone.missed_calls'|translate }}</ng-template>
    <ng-template matTabContent>
      <div fxFlex="grow" fxLayout="column" fxFlexFill>
        <app-missed-call-phone></app-missed-call-phone>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>{{ 'cdr.phone.handled_call'|translate }}</ng-template>
    <ng-template matTabContent>
      <div fxFlex="grow" fxLayout="column" fxFlexFill>
        <calllog-list></calllog-list> 
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
